var Kowloon = "九龙";
var HKStates = {
	"Hong Kong Island": "香港岛",
	Kowloon: Kowloon,
	"Lantau Island": "大屿山",
	"New Territories": "新界"
};

export { Kowloon, HKStates as default };
